import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Drawer from 'material-ui/Drawer';
import FontIcon from 'material-ui/FontIcon';
import { List, ListItem } from 'material-ui/List';
import { Link } from 'react-router';

const propTypes = {
  menuToggle: PropTypes.func,
};

class SideNavBar extends Component {
  constructor() {
    super();
    this.state = {
      openMenu: false,
    };
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      openMenu: nextProps.openMenu,
    });
  }

  handleMenu() {
    this.state.openMenu = !this.state.openMenu;
    this.props.menuToggle();
  }

  render() {
    // List of Icons
    const dashBoardIcon = <FontIcon className="fa fa-home" />;
    const productsIcon = <FontIcon className="fa fa-file-image-o" />;
    const productItemsIcon = <FontIcon className="fa fa-barcode" />;
    const catalogsIcon = <FontIcon className="fa fa-stack-overflow" />;
    const adminsIcon = <FontIcon className="fa fa-user-plus" />;
    const orderIcon = <FontIcon className="fa fa-list" />;
    const pendingOrderIcon = < FontIcon className="fa fa-ellipsis-h" />;
    const cartsIcon = < FontIcon className="fa fa-shopping-cart" />;
    const optionGroupIcon = <FontIcon className="fa fa-map-marker" />;
    const promotionsIcon = <FontIcon className="fa fa-tag" />;
    const discountsIcon = <FontIcon className="fa fa-smile-o" />;
    const settingsIcon = <FontIcon className="fa fa-server" />;
    const campaignsIcon = <FontIcon className="fa fa-pencil-square-o" />;
    const eventsIcon = <FontIcon className="fa fa-pencil-square-o" />;
    const salesChannelsIcon = <FontIcon className="fa fa-road" />;
    const taxrateIcon = <FontIcon className="fa fa-university" />;
    const optionsIcon = <FontIcon className="fa fa-filter" />;
    const optionGroupsIcon = <FontIcon className="fa fa-puzzle-piece" />;
    const categoriesIcon = <FontIcon className="fa fa-folder-open" />;
    const loggingIcon = <FontIcon className="fa fa-bar-chart" />;
    const giftCardsIcon = <FontIcon className="fa fa fa-tag" />;
    const hamburger = <FontIcon className="fa fa-bars" />;
    const reportingIcon = <FontIcon className="fa fa-pie-chart" />;
    const articleIcon = <FontIcon className="fa fa-newspaper-o" />;
    const boxesIcon = <FontIcon className="fa fa-archive" />;
    const overlayIcon = <FontIcon className="fa fa-clone" />;

    const primaryTogglesNestedList = true;

    const hideFulfillment = (['0', '1', '2', '3', '4'].indexOf(localStorage.getItem('scope')) === 3) ? 'none' : 'inline';

    return (
      <Drawer open={this.state.openMenu}>
        <List>
          <ListItem
            leftIcon={hamburger}
            onClick={this.handleMenu}
          />
          <Link
            to="/dashboard"
            onClick={this.handleMenu}
          >
            <ListItem
              primaryText="Dashboard"
              leftIcon={dashBoardIcon}
              primaryTogglesNestedList={primaryTogglesNestedList}
            />
          </Link>
          <ListItem
            primaryText="Orders/Carts"
            leftIcon={orderIcon}
            primaryTogglesNestedList={primaryTogglesNestedList}
            nestedItems={[
              <ListItem
                key={1}
                containerElement={<Link to="/orders?page=1" />}
                primaryText="Orders"
                leftIcon={orderIcon}
                onClick={this.handleMenu}
              />,
              <ListItem
                key={2}
                containerElement={<Link to="/orders?page=1&statuses=pending" />}
                primaryText="Pending Orders"
                leftIcon={pendingOrderIcon}
                onClick={this.handleMenu}
                style={{ display: hideFulfillment }}
              />,
              <ListItem
                key={3}
                containerElement={<Link to="/orders?page=1&statuses=cart" />}
                primaryText="Carts"
                leftIcon={cartsIcon}
                onClick={this.handleMenu}
                style={{ display: hideFulfillment }}
              />,
            ]}
          />
          {(['0'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to="/admins?page=1"
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Admins"
                leftIcon={adminsIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to="/catalogs?page=1"
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Catalogs"
                leftIcon={catalogsIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to="/giftcards?page=1"
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Gift Cards"
                leftIcon={giftCardsIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to="/categories?page=1"
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Categories"
                leftIcon={categoriesIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '2', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <ListItem
              primaryText="Products/Items"
              leftIcon={productsIcon}
              primaryTogglesNestedList={primaryTogglesNestedList}
              nestedItems={[
                <ListItem
                  key={1}
                  containerElement={<Link to="/products?page=1" />}
                  primaryText="Products"
                  leftIcon={productsIcon}
                  onClick={this.handleMenu}
                />,
                <ListItem
                  key={2}
                  containerElement={<Link to="/items?page=1" />}
                  primaryText="Items"
                  leftIcon={productItemsIcon}
                  onClick={this.handleMenu}
                />,
              ]}
            />
            : null}

          {(['0', '1'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to="/overlays?page=1"
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Overlays"
                leftIcon={overlayIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <ListItem
              primaryText="Options/Groups"
              leftIcon={optionsIcon}
              primaryTogglesNestedList={primaryTogglesNestedList}
              nestedItems={[
                <ListItem
                  key={1}
                  containerElement={<Link to="/options?page=1" />}
                  primaryText="Options"
                  leftIcon={optionsIcon}
                  onClick={this.handleMenu}
                />,
                <ListItem
                  key={2}
                  containerElement={<Link to="/optiongroups?page=1" />}
                  primaryText="Option Groups"
                  leftIcon={optionGroupsIcon}
                  onClick={this.handleMenu}
                />,
              ]}
            />

            : null}
            {(['0', '1' ].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to="/boxes"
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Boxes"
                leftIcon={boxesIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '2', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to="/taxrate?page=1"
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Tax Rates"
                leftIcon={taxrateIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to={'/settings'}
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Settings"
                leftIcon={settingsIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

            {(['0', '1'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to={'/articles'}
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Articles"
                leftIcon={articleIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to={'/reporting'}
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Reporting"
                leftIcon={reportingIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              // disabled={!isAdmin}
              />
            </Link>
            : null}

          {(['0', '1', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to={'/saleschannels?page=1'}
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Sales Channels"
                leftIcon={salesChannelsIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <Link
              to={'/campaigns?page=1'}
              onClick={this.handleMenu}
            >
              <ListItem
                primaryText="Campaigns"
                leftIcon={campaignsIcon}
                primaryTogglesNestedList={primaryTogglesNestedList}
              />
            </Link>
            : null}

          {(['0', '1', '2', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <ListItem
              primaryText="Promos/Discounts"
              leftIcon={promotionsIcon}
              primaryTogglesNestedList={primaryTogglesNestedList}
              nestedItems={[
                <ListItem
                  key={1}
                  containerElement={<Link to="/promotions?page=1" />}
                  primaryText="Promotions"
                  leftIcon={promotionsIcon}
                  onClick={this.handleMenu}
                />,
                <ListItem
                  key={2}
                  containerElement={<Link to="/discounts?page=1" />}
                  primaryText="Discounts"
                  leftIcon={discountsIcon}
                  onClick={this.handleMenu}
                />,
              ]}
            />
            : null}

          {(['0', '1', '4'].indexOf(localStorage.getItem('scope')) > -1) ?
            <ListItem
              primaryText="Logging"
              leftIcon={loggingIcon}
              primaryTogglesNestedList={primaryTogglesNestedList}
              nestedItems={[
                <ListItem
                  key={1}
                  containerElement={<Link to="/logging/campaigns?page=1" />}
                  primaryText="Email Campaigns"
                  leftIcon={campaignsIcon}
                  onClick={this.handleMenu}
                />,
                <ListItem
                  key={2}
                  containerElement={<Link to="/events?page=1" />}
                  primaryText="Events"
                  leftIcon={eventsIcon}
                  onClick={this.handleMenu}
                />,
              ]}
            />
            : null}
        </List>

      </Drawer>
    );
  }
}

SideNavBar.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

SideNavBar.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    openMenu: state.layout.menuState,
  };
}

export default connect(mapStateToProps)(SideNavBar);



// WEBPACK FOOTER //
// ./src/components/home/SideNavBar.js